import { render, staticRenderFns } from "./Barcodes.vue?vue&type=template&id=61cf1cb2&scoped=true"
import script from "./Barcodes.vue?vue&type=script&lang=js"
export * from "./Barcodes.vue?vue&type=script&lang=js"
import style0 from "./Barcodes.vue?vue&type=style&index=0&id=61cf1cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf1cb2",
  null
  
)

export default component.exports